export const LOCALES = ['en', 'ar']
export const DEFAULT_LOCALE = 'en'

export const LOCALE_HREFLANG = {
  en: 'en',
  ar: 'ar',
}

export const LOCALE_OG = {
  en: 'en_US',
  ar: 'ar_AE',
}

export function getSiteUrl(host) {
  if (!host) {
    return 'https://elemental.ae'
  }

  const normalized = host.replace(/^https?:\/\//, '').replace(/\/$/, '')
  return `https://${normalized}`
}

export function getPathnameOnly(path = '/') {
  return path.split('?')[0].split('#')[0]
}

export function getPublicPath(fallbackPath = '/') {
  if (typeof window !== 'undefined') {
    return `${window.location.pathname}${window.location.search}`
  }

  return fallbackPath
}

export function getLocaleFromPath(path = '/') {
  const pathname = getPathnameOnly(path)
  const segments = pathname.split('/').filter(Boolean)

  if (segments[0] === 'ar') {
    return 'ar'
  }

  return DEFAULT_LOCALE
}

export function stripLocaleFromPath(path = '/') {
  const pathname = getPathnameOnly(path)
  const segments = pathname.split('/').filter(Boolean)

  if (segments[0] === 'ar') {
    segments.shift()
  }

  return segments.length ? `/${segments.join('/')}` : '/'
}

export function localizePath(path = '/', locale = DEFAULT_LOCALE) {
  const cleanPath = stripLocaleFromPath(path)

  if (locale === DEFAULT_LOCALE) {
    return cleanPath
  }

  if (cleanPath === '/') {
    return `/${locale}`
  }

  return `/${locale}${cleanPath}`
}

export function getCanonicalUrl(path = '/', host) {
  const locale = getLocaleFromPath(path)
  const siteUrl = getSiteUrl(host)

  return `${siteUrl}${localizePath(path, locale)}`
}

export function getAlternateUrls(path = '/', host) {
  const siteUrl = getSiteUrl(host)

  const alternates = LOCALES.map((locale) => ({
    hrefLang: LOCALE_HREFLANG[locale],
    href: `${siteUrl}${localizePath(path, locale)}`,
  }))

  alternates.push({
    hrefLang: 'x-default',
    href: `${siteUrl}${localizePath(path, DEFAULT_LOCALE)}`,
  })

  return alternates
}
